var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressTrackerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 98,
    viewBox: "0 0 156 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2452"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1356",
    x: 2.4001,
    y: 1.89998,
    width: 32.4,
    height: 93.6,
    rx: 5.4,
    fill: "#212A35",
    stroke: "#212A35",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1355",
    x: 13.2001,
    y: 1.89998,
    width: 140.4,
    height: 93.6,
    rx: 5.4,
    fill: "white",
    stroke: "#212A35",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1343",
    x: 17.5877,
    y: 58.3047,
    width: 35.6,
    height: 31.6,
    fill: "#4BF27A",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1344",
    x: 49.5938,
    y: 58.3047,
    width: 35.6,
    height: 31.6,
    fill: "#FC766D",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1345",
    x: 81.6001,
    y: 58.3047,
    width: 35.6,
    height: 31.6,
    fill: "#FFC700",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1346",
    x: 113.606,
    y: 58.3047,
    width: 35.6,
    height: 31.6,
    fill: "#FFC700",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1347",
    x: 17.5877,
    y: 34.3,
    width: 35.6,
    height: 27.6,
    fill: "#4BF27A",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1348",
    x: 49.5938,
    y: 34.3,
    width: 35.6,
    height: 27.6,
    fill: "#4BF27A",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1349",
    x: 81.6001,
    y: 34.3,
    width: 35.6,
    height: 27.6,
    fill: "#FFC700",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1350",
    x: 113.606,
    y: 34.3,
    width: 35.6,
    height: 27.6,
    fill: "#FFC700",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1351",
    x: 17.5877,
    y: 6.30156,
    width: 35.6,
    height: 27.6,
    fill: "#4BF27A",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1352",
    x: 49.5938,
    y: 6.30156,
    width: 35.6,
    height: 27.6,
    fill: "#4BF27A",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1353",
    x: 81.6001,
    y: 6.30156,
    width: 35.6,
    height: 27.6,
    fill: "#4BF27A",
    stroke: "white",
    strokeWidth: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1354",
    x: 113.606,
    y: 6.30156,
    width: 35.6,
    height: 27.6,
    fill: "#4BF27A",
    stroke: "white",
    strokeWidth: 3.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressTrackerIcon);
export default __webpack_public_path__ + "static/media/progressTrackerIcon.a0f2f335b5a71371a6128ee584f8140f.svg";
export { ForwardRef as ReactComponent };